export default {
  description: 'Use o Código: {{code}} para obter desconto nas próximas {{count}} encomendas aqui.',
  discounts: {
    percentage: '{{discount}}%',
    fixed: '{{discount}}',
  },
  list: {
    item: {
      order: '{{orderNumber}}. Encomenda',
    },
  },
  savings: {
    percentage: 'Poupa um total de {{totalSaved}}%',
    fixed: 'Poupa um total de {{totalSaved}}',
  },
  apply: 'Aplicar',
  applied: 'Aplicado',
  remove: 'Remover',
  custom_button: {
    done: 'Concluído',
  },
};
